
import PropTypes from 'prop-types';
import { GenericHeader } from "../../utility/common/TransactionComponents/Generic_WPQ_WPS_PQR_header";
export const WPQHeader = ({ headerObj }) => {
  WPQHeader.propTypes = {
        headerObj : PropTypes.array}
        const headerItems = [
          { label: "Welder Id", value: headerObj?.WPQ_WelderId },
          { label: "Welder Name", value: headerObj?.WPQ_WelderName },
          { label: "Welding Date", value: headerObj?.WPQ_Date },
          { label: "WPQ Record Number", value: headerObj?.WPQ_RecordNo },
          //{ label: "Status", value: headerObj?.WPQ_Status},
          { label: "Last Weld Date", value: headerObj?.WPQ_Last_UpdatedDate}
        ];
        
  return (

    // Example usage:

// Use it like this:
 <GenericHeader headerData={headerItems} />

    
  );
};
{/* <Row style={{ padding: "20px 60px", backgroundColor: "var(--bg-alt-2)" }}  className="WPQ-Page-row-padding">
      <Row className="mb-4">
        <Col md={2}>
          <div className="d-flex flex-column">
            <small>Welder Id</small>
            <strong>{headerObj?.WPQ_WelderId}</strong>
          </div>
        </Col>
        <Col md={2}>
          <div className="d-flex flex-column">
            <small>Welder Name</small>
            <strong>{headerObj?.WPQ_WelderName}</strong>
          </div>
        </Col>
        <Col md={2}>
          <div className="d-flex flex-column">
            <small>Welding Date</small>
            <strong>{headerObj?.WPQ_Date}</strong>
          </div>
        </Col>
        <Col md={2}>
          <div className="d-flex flex-column">
            <small>WPQ Record Number</small>
            <strong>{headerObj?.WPQ_RecordNo}</strong>
          </div>
        </Col>
        <Col md={2}>
          <div className="d-flex flex-column">
            <small>Status</small>
            <strong>{headerObj?.WPQ_Status}</strong>
          </div>
        </Col>
        <Col md={2}>
          <div className="d-flex flex-column">
            <small>Last Weld Date</small>
            <strong>{headerObj?.WPQ_Last_UpdatedDate}</strong>
          </div>
        </Col>
      </Row>
    </Row>
 */}